import React, { useState } from 'react';
import axios from 'axios';
import styles from './Withdrawal.module.css'; // CSS 모듈

import HeaderSection from '../all_pages/HeaderSection';  // HeaderSection 컴포넌트 불러오기

import { useNavigate } from 'react-router-dom';

const Withdrawal = () => {
const [step, setStep] = useState(1); // 1: 비밀번호 검증, 2: 새 비밀번호 설정
const [currentPassword, setCurrentPassword] = useState(''); // 입력된 비밀번호 가져오기
const [message, setMessage] = useState(''); // 메세지

const [isProcessing, setIsProcessing] = useState(false); // 처리 중 상태 이게 왜 필요하지

const [isPasswordVerified, setIsPasswordVerified] = useState(false);
const [isVerifyDisabled, setIsVerifyDisabled] = useState(false); // 확인 버튼 비활성화 상태

const apiUrl = process.env.REACT_APP_API_URL;

const navigate = useNavigate(); // navigate 정의
const nextStep = () => setStep(step + 1);
const prevStep = () => setStep(step - 1);


// 비밀번호 검증 핸들러
const handleVerifyPassword = async () => {
    setMessage(''); // 이전 메시지 초기화
    try {
    const response = await axios.post(
        `${apiUrl}/accounts/verify_password/`,
        { password: currentPassword },
        {
        headers: {
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },  
        }
    );

    if (response.status === 200) {
        // setStep(2); // 다음 단계로 이동
        setIsPasswordVerified(true); // 비밀번호 확인 상태 업데이트
        setMessage('비밀번호 검증 성공!');
        setIsVerifyDisabled(true); // 확인 버튼 비활성화
    }
    } catch (error) {
        if (error.response?.status === 401) {
            // 401 Unauthorized 처리
            alert('올바른 접근이 아닙니다.');
            navigate('/login'); // 로그인 페이지로 리디렉션
        } else {
            // 다른 오류 처리
            const errorMessage =
                error.response?.data?.error || '비밀번호가 맞지 않아요. 다시 확인해주세요!';
            setMessage(errorMessage); // 오류 메시지 표시
        }
        setIsPasswordVerified(false); // 비밀번호 확인 실패 시 상태 초기화
        setIsVerifyDisabled(false); // 확인 버튼 다시 활성화
    }
};
///////////////////////////////////////////////////////////////////////////////// 비밀번호 검증 핸들러 끝



//// 로그아웃
const handleLogout = async () => {
    const refreshToken = localStorage.getItem('refreshToken');
    const accessToken = localStorage.getItem('accessToken');

    try {
    await axios.post(
        `${process.env.REACT_APP_API_URL}/accounts/logout/`,
        { refresh: refreshToken },
        {
        headers: {
            Authorization: `Bearer ${accessToken}`,
        },
        }
    );

    // 로그아웃 성공 시 토큰 및 사용자 정보 제거
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('username');
    navigate('/login');
    } catch (error) {
    console.error('로그아웃 실패:', error);

    // 에러 발생 시 메시지 출력 및 로그인 페이지로 리디렉션
    alert('정상적인 접근이 아닙니다.');
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('username');
    navigate('/login');
    }
};
///////////////////////////////////////////////////////////////////////////////// 로그아웃 끝


//// 회원탈퇴
const handleDeactivateAccount = async () => {
    setMessage(''); // 이전 메시지 초기화
    setIsProcessing(true); // 처리 중 상태로 전환
    try {
        const response = await axios.post(
            `${apiUrl}/accounts/deactivate/`,
            {}, // 데이터가 필요하지 않음
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
                },
            }
        );

        if (response.status === 200) {
            setMessage('회원 탈퇴가 완료되었습니다.');
            localStorage.clear(); // 로컬 스토리지 초기화
            nextStep()
        }
    } catch (error) {
        if (error.response?.status === 401) {
            // 401 Unauthorized 처리
            alert('올바른 접근이 아닙니다.');
            navigate('/login'); // 로그인 페이지로 리디렉션
        } else {
            // 다른 오류 처리
            const errorMessage =
                error.response?.data?.message || '회원 탈퇴 중 문제가 발생했습니다. 다시 시도해주세요.';
            setMessage(errorMessage); // 오류 메시지 표시
        }
    } finally {
        setIsProcessing(false); // 처리 상태 초기화
    }
};
///////////////////////////////////////////////////////////////////////////////// 회원탈퇴 끝

const offend = async () => {
    localStorage.clear(); // 로컬 스토리지 초기화
    navigate('/login'); // 로그인 페이지로 리디렉션
};
    return (
        <div className={styles.pageContainer}>
        {step === 1 && (
        <div className={styles.step}>
            <HeaderSection 
                title="탈퇴하기" 
                onBack={() => navigate('/mypage')} 
                // onCancel={() => navigate('/login')} 
            />    
            <p className={styles.headers_text}>탈퇴를 위해 <br />비밀번호를 입력해주세요</p>
            <div className={styles.signupInputContainer}>
                <label className={styles.signupLabel}>비밀번호</label>
                <div className={styles.inputWithButton}>
                    <input 
                        type="password"
                        placeholder="비밀번호를 입력해주세요"
                        value={currentPassword}
                        onChange={(e) => setCurrentPassword(e.target.value)}
                        className={styles.input}
                        disabled={isPasswordVerified} // 비밀번호 확인 완료 시 비활성화
                    />


                    {/* 아이디 중복 버튼 */}
                    <button
                        className={styles.checkButton}
                        onClick={handleVerifyPassword} // 닉네임 중복 체크 버튼 클릭 시 실행
                        disabled={isPasswordVerified || currentPassword.trim() === ''}
                        // disabled={loginIdLoading || !validateLoginID(loginId)|| isLoginidAvailable} // 중복 체크 중이거나 닉네임 유효성 체크 실패 시 비활성화
                    >
                    확인
                    </button>
                </div>
                </div>

                {message && (
                    <p
                        className={
                        isPasswordVerified ? styles.successMessage : styles.errorMessage
                        }
                    >
                        {message}
                    </p>
                )}

            {/* 하단 고정 버튼 */}
            <div className={styles.nextButtonContainer}>
                <button 
                className={styles.nextButton} 
                onClick={nextStep}
                disabled={!isPasswordVerified} // 비밀번호 확인이 완료되기 전까지 비활성화
                >
                다음으로
            </button>
            </div>
        </div>
    )}

    {step === 2 && (
        <div className={styles.step}>
        <HeaderSection 
            title="탈퇴하기" 
            onBack={() => navigate('/mypage')} 
            // onCancel={() => navigate('/login')} 
        />    
        <p className={styles.headers_text}>탈퇴하기 전 <br/> 확인해주세요!</p>
        
        <div className={styles.middletextbox}>

            <p className={styles.middletextboxtext1}>글로업에서 진행한 적성검사 유형, 퀘스트 내용 및 진행 이력은 곧바로 삭제되며 복구되지 않습니다. <br/>탈퇴 시 계정은 곧바로 삭제됩니다.</p>
            <br/>
            <p className={styles.middletextboxtest2}>글로업과 함께 빛나는 시간이 되셨길 바랍니다. <br/> 감사합니다!</p>

        </div>


        {/* 하단 고정 버튼 */}
        <div className={styles.nextButtonContainer}>
            <button 
                className={styles.nextButton} 
                onClick={handleDeactivateAccount}
                /// 여기에 회원탈퇴 (상태 변경) 로직 추가
                disabled={!isPasswordVerified} // 비밀번호 확인이 완료되기 전까지 비활성화
                >
                탈퇴하기
            </button>
        </div>
        </div>
    )}
    {step === 3 && (
    <div className={styles.step}>
    <HeaderSection 
        title="탈퇴하기" 
        // onBack={() => navigate('/mypage')} 
        // onCancel={() => navigate('/login')} 
    /> 
    <p className={styles.headers_text}>탈퇴가 완료되었습니다.</p>


    {/* 하단 고정 버튼 */}
    <div className={styles.nextButtonContainer}>
        <button 
            className={styles.nextButton} 
            onClick={offend}
            /// 여기에 회원탈퇴 (상태 변경) 로직 추가
            disabled={!isPasswordVerified} // 비밀번호 확인이 완료되기 전까지 비활성화
            >
            확인
        </button>
    </div>

    </div>
    )}
        </div>
    );
};

export default Withdrawal;
